<template>
  <div class="m-featured tw-rounded-[20px]">
    <div
      v-if="gameCards.length"
      class="m-featured-title"
    >
      <!-- for seo -->
      <h2 style="display: none">Featured Matches</h2>
      <img
        :src="titleImage"
        alt="Featured Matches"
        height="21px"
      />
    </div>
    <div class="tw-pt-[10px] tw-pb-[20px]">
      <Swiper
        class="tournament-navs"
        :options="navSwiperOption"
      >
        <SwiperSlide
          v-for="item in featuredMatches.tournaments"
          :key="item.tournamentId"
        >
          <button
            type="button"
            class="nav-item"
            :class="{
              active: currentId === item.tournamentId
            }"
            @click="handleChangeTournament(item.tournamentId)"
          >
            <img
              v-if="item.tournamentIcon"
              :src="item.tournamentIcon"
              alt=""
              class="tw-h-[18px]"
              loading="lazy"
            />
            <img
              v-else
              src="../images/default-tournament.png"
              alt=""
              class="tw-h-[18px]"
              loading="lazy"
            />
            <span
              v-if="currentId === item.tournamentId"
              class="name tw-ml-[4px]"
              >{{ item.tournament }}</span
            >
          </button>
        </SwiperSlide>
      </Swiper>

      <template v-for="item in featuredMatches.tournaments">
        <!-- 类名 swiper-no-swiping 可以阻止 swiper 滑动 -->
        <Swiper
          v-if="currentId === item.tournamentId"
          :key="`tab-${item.tournamentId}`"
          ref="featuredSwiper"
          v-model="activeIndex"
          :options="swiperOption"
          :class="{
            'swiper-no-swiping': events.order.length === 1
          }"
          @slide-change="onChangeSlide"
        >
          <template v-for="(eventId, index) in events.order">
            <SwiperSlide :key="eventId">
              <FeaturedEvent
                v-if="index <= hasLoadIndex"
                :event="events.map[eventId]"
                :background-image="item.tournamentBgImg"
                :count="item.count"
              />
            </SwiperSlide>
          </template>
          <SwiperSlide
            ref="featuredCardsMore"
            :key="`${item.tournamentId}-more`"
            :class="['slide-more', { 'tw-rounded-[8px]': isViewMore }]"
            @click="jumpToMore(item.tournamentId)"
          >
            More
          </SwiperSlide>
        </Swiper>
      </template>
    </div>
  </div>
</template>

<script>
import eventBus from '@ms/utils/event-bus'
import { storeToRefs } from 'pinia'
import { Swiper, SwiperSlide } from 'vue-slim-swiper'
import { useThemeImage } from 'composables/useThemeImage'
import FeaturedEvent from '../components/FeaturedEvent'
import useHomeStore from 'wap/stores/home'
import { useGameCardsStore } from '@ms/stores/gameCards'

export default {
  name: 'Featured',
  components: {
    Swiper,
    SwiperSlide,
    FeaturedEvent
  },
  setup() {
    const { featuredMatches } = storeToRefs(useHomeStore())

    const game = useGameCardsStore()
    const { gameCards } = storeToRefs(game)

    const titleImage = useThemeImage({
      light: {
        default: require('../images/featured-matches-light.png')
      },
      dark: {
        default: require('../images/featured-matches.png')
      }
    })

    return {
      featuredMatches,
      gameCards,
      titleImage
    }
  },
  data() {
    return {
      activeIndex: 0,
      currentId: '',
      navSwiperOption: {
        slidesPerView: 'auto'
      },
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 8,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 0,
        freeMode: {
          enabled: true,
          sticky: true,
          momentumRatio: 0.5,
          momentumVelocityRatio: 0.8
        }
      },
      preLoadNum: 2,
      hasLoadIndex: 0,
      isViewMore: false
    }
  },
  computed: {
    events() {
      return this.featuredMatches.tournamentMap[this.currentId]
    }
  },
  created() {
    this.currentId = this.featuredMatches.tournaments[0].tournamentId
    this.hasLoadIndex = this.preLoadNum
    this.$nextTick(() => {
      this.setMoreRadius()
      eventBus.$emit('bubbleBall_move')
    })
  },
  deactivated() {
    // 取消订阅
    useHomeStore().subFeaturedMatches(false)
  },
  beforeDestroy() {
    // 取消订阅
    useHomeStore().subFeaturedMatches(false)
  },
  methods: {
    onChangeSlide() {
      // 防止加载完的slide,在回滑动时后边瞬间消失，即已加载完成的不在消失
      if (this.hasLoadIndex < this.events.order.length) this.hasLoadIndex = this.activeIndex + this.preLoadNum
      window.mstrace('Home_FeatureMatch_Switch', 'Home')
    },
    handleChangeTournament(tournamentId) {
      if (this.currentId === tournamentId) return
      this.currentId = tournamentId
      this.activeIndex = 0
      this.hasLoadIndex = this.preLoadNum
      this.isViewMore = false
      this.$nextTick(() => {
        this.setMoreRadius()
      })
      window.mstrace('FeatureMatch_LeagueSwitch')
    },
    jumpToMore(tournamentId) {
      this.$router.push({
        name: 'matchList',
        query: {
          t: tournamentId
        }
      })
      window.mstrace('FeatureMatch_More')
    },
    setMoreRadius() {
      const width = document.body.clientWidth
      const { right } = this.$refs.featuredCardsMore[0].$el.getBoundingClientRect()
      this.isViewMore = right < width
    }
  }
}
</script>

<style lang="less">
@import url('~wap/common/style/variable.less');

.m-featured {
  overflow: hidden;
  margin: 0 0 16px;
  background: #161616;

  &-title {
    height: 21px;
    padding: 14px 20px 5px;
    background-image: linear-gradient(172deg, rgba(255, 202, 39, 37%) 0%, rgba(22, 22, 22, 37%) 50%);
    line-height: 21px;
  }

  .tournament-navs {
    padding: 0 0 10px;

    .swiper-slide {
      width: auto;

      &:first-child {
        .nav-item {
          margin-left: 20px;
        }
      }
    }

    .nav-item {
      position: relative;
      display: flex;
      min-width: 32px;
      height: 32px;
      box-sizing: border-box;
      flex: none;
      align-items: center;
      justify-content: center;
      padding: 0 4px;
      border-radius: 6px;
      margin-right: 8px;
      cursor: pointer;
      line-height: 32px;
      text-align: center;
      white-space: nowrap;

      &::before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border: 1px solid;
        border-color: #333;
        border-radius: 6px;
        content: '';
      }

      &.active {
        position: relative;
        width: auto;
        padding: 0 16px 0 4px;
        background: #2b2b2b;
        color: #fff;
        font-size: 12px;
        font-weight: bold;

        &::before {
          display: none;
        }
      }
    }
  }

  // 注意这个 swiper-no-swiping classname 还有阻止滑动的功能。不要改名
  .swiper-no-swiping {
    .swiper-slide.slide-more {
      width: 67px;
      max-width: 134px;
    }
  }

  .swiper-slide {
    width: 280px;
    max-width: 556px;

    &.slide-more {
      display: flex;
      width: 65px;
      max-width: 120px;
      height: 135px;
      box-sizing: border-box;
      align-items: center;
      padding-left: 16px;
      border-radius: 8px 0 0 8px;
      margin-right: 0 !important;
      background: #1b1b1b;
      color: #999;
      font-size: 12px;
    }
  }
}
</style>

<style lang="scss">
[data-mode='light'] .m-featured {
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 7%);

  &-title {
    background-image: linear-gradient(174deg, rgba(255, 202, 39, 27%) 0%, #fff 50%);
  }

  .tournament-navs {
    .nav-item {
      &::before {
        border-color: #ececec;
      }

      &.active {
        background-image: linear-gradient(-75deg, #ffe74f 0%, #ffad31 100%);
        color: #000;
      }
    }
  }

  .swiper-slide {
    &.slide-more {
      border: 1px solid #fff0c4;
      border-right: none;
      background: #fff;
      box-shadow: 2px 0 10px -10px #000;
      color: #333;
    }
  }
}
</style>
